// Toggle password input type to text and back
const showPassword = () => {
  console.log("Loaded toggle script")

  const passwordField = document.querySelectorAll("input.user-password");

  const toggleButton = document.querySelectorAll("span.toggleButton");
  console.log(toggleButton)
  toggleButton.forEach((btn, index) => { btn.addEventListener('click', () => {
    if(passwordField[index].getAttribute("type") == "password"){
      passwordField[index].setAttribute("type", "text")
      toggleButton[index].classList.toggle('open')
    }else{
      passwordField[index].setAttribute("type", "password")
     toggleButton[index].classList.toggle('open')
    }
  })
  })

}
showPassword()
